var searcIconhBlue = "<svg width=\"17\" height=\"18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.5 14c3.5898509 0 6.5-2.9101491 6.5-6.5S11.0898509 1 7.5 1 1 3.9101491 1 7.5 3.9101491 14 7.5 14zm4.5-1l4 4\" stroke=\"#7B93AF\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>";

export { searcIconhBlue as default };
